/** @jsx jsx */
import { jsx } from '@emotion/react';

import { useRetracked } from 'js/lib/retracked';

import { Button, ContextualHelp, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/browse';

type Props = {
  description: string;
  domainId: string;
  title: string;
  label: JSX.Element;
};

const DescriptionBubble = ({ title, description, domainId, label }: Props) => {
  const titleInfo = `${title} ${_t('information')}`;
  const retrackedTrack = useRetracked();

  return (
    <ContextualHelp
      id={domainId}
      invert={true}
      helpToggleProps={{
        'aria-label': titleInfo,
      }}
      label={label}
      tooltipProps={{
        closeButtonProps: {
          'aria-label': _t('close #{titleInfo}', { titleInfo }),
        },
      }}
      onChange={() => {
        retrackedTrack({
          trackingData: { domain: domainId },
          trackingName: 'domain_description_bubble',
          action: 'click',
        });
      }}
    >
      {({ onClose, isExpanded = false }) => (
        <Dialog aria-describedby="dialog-content" open={isExpanded} onClose={onClose}>
          <Dialog.HeadingGroup>{title}</Dialog.HeadingGroup>
          <Dialog.Content id="dialog-content">
            <Typography2 component="p">{description}</Typography2>
          </Dialog.Content>

          <Dialog.Actions>
            <Button data-testid="got-it-button" size="medium" variant="primary" onClick={onClose}>
              {_t('Got it')}
            </Button>
          </Dialog.Actions>
        </Dialog>
      )}
    </ContextualHelp>
  );
};

export default DescriptionBubble;
